import styled from 'styled-components';

export const Button = styled.button`
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;

    color: var(--main-purple);
`;